let detectionResult: boolean | null = null;
let userAgentLogged = false;

export function isIOSWebViewGold(): boolean {
  if (detectionResult !== null) {
    return detectionResult;
  }

  const ua = navigator.userAgent;

  if (!userAgentLogged) {
    console.log('[WebViewGold Detection] Full User-Agent:', ua);
    userAgentLogged = true;
  }

  const hasWebViewGold = ua.includes('WebViewGold') || ua.includes('WebViewGold;');

  const isIOSDevice = /iPhone|iPad|iPod/i.test(ua);

  detectionResult = hasWebViewGold && isIOSDevice;

  console.log('[WebViewGold Detection] Result:', {
    hasWebViewGold,
    isIOSDevice,
    finalResult: detectionResult,
    detectionMethod: 'User-Agent'
  });

  return detectionResult;
}

export function getDetectionInfo() {
  const ua = navigator.userAgent;
  const hasWebViewGold = ua.includes('WebViewGold') || ua.includes('WebViewGold;');
  const isIOSDevice = /iPhone|iPad|iPod/i.test(ua);

  return {
    userAgent: ua,
    hasWebViewGold,
    isIOSDevice,
    isIOSWebViewGold: hasWebViewGold && isIOSDevice,
    detectionMethod: 'User-Agent',
    detectionTime: new Date().toISOString()
  };
}

export function resetDetection(): void {
  detectionResult = null;
  userAgentLogged = false;
  console.log('[WebViewGold Detection] Detection cache cleared');
}
